export type LivrableState = {
  idLivrableCreated: string;
  filtre: string;
};

export const initialState: LivrableState = {
  idLivrableCreated: '',
  filtre: '',
};
